import { ISensor } from '../models/sensor.model';
import { JunctionBoxSlot } from '../models/junctionbox.model';
import {
  JUNCTION_BOX_SELECTION,
  JUNCTION_BOX_SELECTION_PIPE,
} from '../constants/junctionBox.constant';

export class SensorUtil {
  /**
   * Get sensor display label combining junction box slot and sensor name
   */
  static getSensorDisplayLabel(sensor: ISensor): string {
    const slotLabel = this.getJunctionBoxSlotLabel(sensor);
    return slotLabel + (sensor.sensorName ? ' | ' + sensor.sensorName : '');
  }

  /**
   * Get junction box selection based on parent equipment type
   */
  static getJunctionBoxSelection(sensor: ISensor): JunctionBoxSlot[] {
    return sensor.parentEquipmentType && sensor.parentEquipmentType.toLocaleLowerCase() === 'pipe'
      ? JUNCTION_BOX_SELECTION_PIPE
      : JUNCTION_BOX_SELECTION;
  }

  /**
   * Get junction box slot label
   */
  static getJunctionBoxSlotLabel(sensor: ISensor): string {
    const junctionBoxSelection = this.getJunctionBoxSelection(sensor);
    const slot = junctionBoxSelection.find((j) => j.value === sensor.junctionBoxSlot);
    return slot?.label ?? 'S-';
  }

  /**
   * Check if sensor is a leakage sensor
   */
  static isLeakageSensor(sensor: ISensor): boolean {
    return sensor.sensorTypeID === 1003;
  }

  /**
   * Check if sensor is a steam trap sensor
   */
  static isStreamTrap(sensor: ISensor): boolean {
    return sensor.sensorTypeID === 1005;
  }

  /**
   * Check if sensor is rotating equipment sensor
   */
  static isRotatingEquipment(sensor: ISensor): boolean {
    return sensor.sensorTypeID === 1009;
  }
}
